"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

require("../../stylesheets/components/common/SessionExpiringModal.css");

var _Modal = _interopRequireDefault(require("../common/Modal"));

var _CustomButton = _interopRequireDefault(require("../common/CustomButton"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _class, _class2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var SessionExpiringModalView = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionExpiringModalView, _React$Component);

  var _super = _createSuper(SessionExpiringModalView);

  function SessionExpiringModalView() {
    _classCallCheck(this, SessionExpiringModalView);

    return _super.apply(this, arguments);
  }

  _createClass(SessionExpiringModalView, [{
    key: "handleExtendSession",
    value: function handleExtendSession(e) {
      this.props.dispatcher.emit("SESSION_EXTEND");
    }
  }, {
    key: "handleEndSession",
    value: function handleEndSession(e) {
      this.props.dispatcher.emit("LOGOUT");
    }
  }, {
    key: "render",
    value: function render() {
      var model = this.props.expiringModal; // TODO: Modal button area as a subsection you can add?

      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        className: "session-expiring-modal",
        title: "Session Inactivity",
        modalKey: "sessionExpiring",
        isOpen: model.isOpen
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "session-expiration-info"
      }, /*#__PURE__*/_react.default.createElement("h4", null, "Your session is about to expire!"), /*#__PURE__*/_react.default.createElement("p", null, "For your safety we will log your account if you are not interacting with Gradifi for a long period of time."), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "To prevent this click anywhere on the screen or press \"I'm here\" below.")), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Your session will expire in ", model.remainingTime, " seconds."))), /*#__PURE__*/_react.default.createElement("div", {
        className: "session-expiration-modal-buttons"
      }, /*#__PURE__*/_react.default.createElement(_CustomButton.default, {
        text: "I'm here",
        className: "session-extend",
        onClick: this.handleExtendSession
      }), /*#__PURE__*/_react.default.createElement(_CustomButton.default, {
        text: "Logout",
        className: "session-logout",
        onClick: this.handleEndSession
      })));
    }
  }]);

  return SessionExpiringModalView;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  expiringModal: _propTypes.default.object
}), _class3), (_applyDecoratedDescriptor(_class2.prototype, "handleExtendSession", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleExtendSession"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleEndSession", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "handleEndSession"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(SessionExpiringModalView, {
  "sessionStore": ["expiringModal"]
});

exports.default = _default;